import { render, staticRenderFns } from "./ProductWishlistsDropdown.vue?vue&type=template&id=d3f5f174&"
import script from "./ProductWishlistsDropdown.vue?vue&type=script&lang=js&"
export * from "./ProductWishlistsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ProductWishlistsDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports